<template>
  <section class="" style="height: 0vh;">
   
        <div class="hero">
		  		<div class="hero-content">
		  			<h1 class="hero-title">
		  				EMMANUELLE VIGNON
		   			</h1>
		   			<h2 class="hero-subtitle">
		   				<span></span>
		   				 <textra :data='words' :timer="2.5" filter="simple" infinite="true" />
		   				<span></span>
		   			</h2>
				</div>
			</div>
   

    </section>
</template>

<script>

export default {
metaInfo: function(){
	return{
    title: "Emmanuelle Vignon",
    titleTemplate: '%s | Sophrologue',
        meta: [
      { hid: "description", name: "description", content: " Sophrologue à Blois " },
      { hid: "keywords", name: "keywords", content: " test1 " }      //you can also add open graph tags here
    ]
  }},
data () {
    return {
      words: ["SOPHROLOGUE","Diplômée CEAS Paris"]
    }
  }

  }

</script>

<style scoped>
footer{
	margin-top: -26px;
	z-index: 2;
}
.hero {
    position: relative;
    width: 100vw;
    /*height: 100vh;*/
}
.hero::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /*background: url(../assets/img/aquarelle.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;*/
}
.hero-content {
    position: relative;
}
.hero {
    position: relative;
    width: 100vw;
    height: calc(100vh - 25px);
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(29,41,164);
}
.hero-content {
    position: relative; 
    font-family: "brandon_textlight", sans-serif!important;
    text-align: center;
    margin: 0.625rem;
}
.hero-title {
    font-size: 2.5rem;
    margin-bottom: 0;
    letter-spacing: 4px;
}
.hero-subtitle {
    font-size: 1.5rem;
	margin-top: 0.5rem;
	white-space: nowrap;
	text-align: center;
	display: flex;
    align-items: center;
    height: 38.4px;
}

.hero-subtitle span {
    content:"";
    flex: 1 1 auto;
    border-top: solid 2px rgb(29,41,164);
}

@media (min-width: 576px) {
.hero-title {
    font-size: 3rem;
}
.hero-subtitle {
    font-size: 2rem;
}
}
</style>
